export class IncidentalAbsenceDialogParams {
    empName: string;
    empId: string;
    hrMasterUid: string;
    empUnum: string;
    encryptedEmployeeId: string;
}